// This file is generated by a script and should not be modified directly.
const markdown: string =
  "Les informations de localisations sont composés du:\n\n- Du `centre` de la commune\n- De la boite englobante (`bbox`) qui délimite la zone de la commune.\n\nLes champs `centre` et `bbox` sont tous les deux au format [GeoJSON](https://fr.wikipedia.org/wiki/GeoJSON)\n"
export default markdown
